import { render, staticRenderFns } from "./UserMenuMobileDialog.vue?vue&type=template&id=2fad5fb2&"
import script from "./UserMenuMobileDialog.vue?vue&type=script&lang=ts&"
export * from "./UserMenuMobileDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenuMobileDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
